import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { useSearchTicketsQuery } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.hooks';
import { SEARCH_TICKETS_QUERY_FIELD_NAME } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.dfc.new';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { generateDateFilter, sortFieldsToStrings } from '../constants/filters';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
import { getPreviewTicketListings } from './previewMocks';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
function mapResultToTicket(record) {
  const properties = {};
  for (const [key, value] of Object.entries(record)) {
    properties[key] = convertFieldValueAvroToJson(value);
  }
  const hsTicketId = properties.hs_ticket_id;
  if (typeof hsTicketId !== 'number') {
    throw new TypeError('Search result is missing a numeric hs_ticket_id');
  }
  return Object.assign({}, properties, {
    hs_ticket_id: hsTicketId
  });
}
export const DEFAULT_PAGE_LENGTH = 10;
export const GET_TICKET_LISTINGS_SEARCH_KEY = SEARCH_TICKETS_QUERY_FIELD_NAME;
export const useTicketListingsSearch = ({
  pageLength = DEFAULT_PAGE_LENGTH,
  offset,
  pollInterval = 15000,
  sort,
  searchString,
  createDateFilter,
  lastActivityFilter,
  ticketView,
  statusFilter
}) => {
  var _data$results, _data$total;
  const {
    isPreview
  } = getIsPreview();
  const dateFilters = [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(f => f != null);
  const _useSearchTicketsQuer = useSearchTicketsQuery({
      skip: isPreview,
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketView,
          statusFilter,
          searchString: searchString || undefined,
          sort,
          dateFilters,
          offset,
          pageLength
        }
      },
      pollInterval,
      skipPollAttempt: () => document.visibilityState === 'hidden'
    }),
    {
      data,
      loading,
      refetch
    } = _useSearchTicketsQuer,
    rest = _objectWithoutPropertiesLoose(_useSearchTicketsQuer, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  if (isPreview) {
    const preview = getPreviewTicketListings({
      searchString,
      createDateFilter,
      lastActivityFilter,
      offset,
      limit: pageLength,
      sort: sortFieldsToStrings(sort),
      statusFilter,
      ticketView
    });
    return Object.assign({
      data: preview.results,
      total: preview.total,
      refetch,
      loading: false
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 || (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.map(mapResultToTicket),
    total: (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0,
    refetch,
    loading
  }, rest);
};